<template>
  <ShortcutPage :release="release"></ShortcutPage>
</template>
<script>
import ShortcutPage from './ShortcutPage'

export default {
  name: 'Bretzel',
  data: function() {
    return { release: null }
  },
  components: {
    ShortcutPage,
  },
  mounted: function () {
    this.release = {
      img: '/img/single-bretzel.png',
      name: 'Bretzel & Gingerbread',
      type: 'single',
      links: [
        {
          service: 'bandcamp',
          url: 'https://grizzlycogs.bandcamp.com/track/bretzel-gingerbread-single',
          btnLabel: 'Listen'
        },
        {
          service: 'spotify',
          url: 'https://open.spotify.com/intl-fr/album/0cYPQoUug0ZLqidL73gtup?si=y_DtjOcLT9eMX-DAzgdbjg',
          btnLabel: 'Listen'
        },
        {
          service: 'youtube',
          url: 'https://youtu.be/NTlG7fjgAR4?si=Ko-NxamVtFHe3dP4',
          btnLabel: 'Listen'
        },
        {
          service: 'deezer',
          url: 'https://link.deezer.com/s/32oYsN9LeZzTBsOVdTs9E',
          btnLabel: 'Listen'
        },
        {
          service: 'apple',
          url: 'https://music.apple.com/fr/song/bretzel-gingerbread/1874848438',
          btnLabel: 'Listen'
        },
        {
          service: 'amazon',
          url: 'https://amazon.fr/music/player/albums/B0GLH23TDP?marketplaceId=A13V1IB3VIYZZH&musicTerritory=FR&ref=dm_sh_hefJJhckXHcKP003kXcjWOJcd',
          btnLabel: 'Buy'
        },
        {
          service: 'tidal',
          url: 'https://tidal.com/album/495861454',
          btnLabel: 'Listen'
        }
      ]
    }
  }
}
</script>